import React from "react";
import {Link} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import Button from 'components/buttons/';
import loadingStore from "common/page/store/LoadingStore";
import UIUtil from "../../../../utils/UIUtils";

function ContentsContainer() {
    const [touchEnExInstall, setTouchEnExInstall] = React.useState(false);
    const [delfinoInstall, setDelfinoInstall] = React.useState(false);

    const TouchEnNx = window["TouchEnNx"];
    const TOUCHENEX_UTIL = window["TOUCHENEX_UTIL"];
    const TouchEnNxConfig = window["TouchEnNxConfig"];
    const useTouchEnnxKey = window["useTouchEnnxKey"];
    const touchenexInfo = window["touchenexInfo"];
    const TOUCHENEX_CHECK = window["TOUCHENEX_CHECK"];
	const TOUCHENEX_INSTALL = window["TOUCHENEX_INSTALL"];
	const tekOption = window["tekOption"];

    const DC_browserInfo = window["DC_browserInfo"];
    const DCryptoPlugin = window["DCryptoPlugin"];
	const DelfinoConfig = window["DelfinoConfig"];
	const DC_platformInfo = window["DC_platformInfo"];
	const Delfino = window["Delfino"];
	const delfino = window["delfino"];
	const wiz = window["wiz"];
	const Delfino_readCookie = window["Delfino_readCookie"];
    let TouchEnNxKeyInstall:NodeJS.Timer;
    const isTouchEnNxReplace = React.useRef(false);
    const isDelfinoReplace = React.useRef(false);

    /*
     * TouchEn ex 설치 점검
     */
    const checkTouchEnNx = () => {
        try {
            if (TouchEnNxConfig.use.nxkey && useTouchEnnxKey) {
                TouchEnNx.useModule = [touchenexInfo];
            }
        } catch (e) {
            console.error("loadmodule check", "install");
        }
        if (TouchEnNx.useModule.length > 0) {
            TouchEnNxKeyInstall = setInterval(() => {
                TOUCHENEX_CHECK.check(TouchEnNx.useModule, (result: { status: any; info: {
                        EX: boolean;
                        EXVer: string;
                        client: boolean;
                        clientVer: string;
                        daemon: boolean;
                        daemonVer: string;
                        isInstalled: boolean;
                        licExpire: string;
                        license: boolean;
                        name: string;
                    }[]; }) => {
                    console.log(result);
                    if (result.status) {
						setTouchEnExInstall(true);
                        clearInterval(TouchEnNxKeyInstall);

                        if(isTouchEnNxReplace.current) {
                            refreshButtonClickHandle();
                        }
                    } else {
                        isTouchEnNxReplace.current = true;

                        /** 솔루션 미설치 일 때*/
                        for (let i = 0; i < result.info.length; i++) {
                            if (!result.info[i].isInstalled) {
                                if (TouchEnNx.useModule[i].exModuleName == "nxkey") {
                                    /** 키보드보안 Client 미설치 */
                                    setTouchEnExInstall(false);
                                }
                            } else {
                                if (TouchEnNx.useModule[i].exModuleName == "nxkey") {
                                    /**키보드보안 설치 완료 */
                                    setTouchEnExInstall(true);
                                }
                            }

                        }
                    }

                });
            }, 100);
        }
    }
    const touchEnExDownloadClickHandler = async () => {
        await UIUtil.alert(<>보안프로그램 설치 완료 후<br/>새로고침 진행해 주세요</>)

		if( (TOUCHENEX_UTIL.isWin() || TOUCHENEX_UTIL.isMac()) && (tekOption.runtype == "onlydaemon" || tekOption.runtype == "mainextension"))
		{
			TOUCHENEX_INSTALL.download('nxkey', 'daemon');
		}
		else
		{
			TOUCHENEX_INSTALL.download('nxkey', 'client');
		}
	}

	/*
	 * Delfino 설치 점검
	 */
	let g_aliveChecker: { stop: () => void; start: () => void; };
	let g_tryExecCount = 1;
	let load_cnt = 0;
	let autoInstall = true;

	function isInstallDelfino() {
		if (DC_browserInfo.MSIE) return DCryptoPlugin.isInstallActiveX();
		return DCryptoPlugin.isInstallPlugin(true);
	}

	function delfino_load() {
        loadingStore.increaseCount();
        if (Delfino.getModule() == "G3") {
            g_aliveChecker = new wiz.util.timer(1000, function () {
                delfino.handler.helper.isInstall({
                    "error": () => {
                        isDelfinoReplace.current = true;
                        loadingStore.decreaseCount();
                    },
					"success": () => {
						// WizIN-Delfino 설치 완료
                        g_aliveChecker.stop();
						setDelfinoInstall(true);
                        if (isDelfinoReplace.current) {
                            refreshButtonClickHandle();
                        }
                        loadingStore.decreaseCount();
                    }
                });
            });
            g_aliveChecker.start();
            return;
        }

        try {
            if (isInstallDelfino()) {
				setDelfinoInstall(true);
            } else {
                load_cnt++;
                if (!DC_browserInfo.MSIE) document.location.reload();
                if (DC_browserInfo.MSIE && !autoInstall && load_cnt >= 3 && Delfino_readCookie("PageReload") == "Y") document.location.reload();
                setTimeout(delfino_load, 1000);
            }
        } catch (err) {
            if (DC_browserInfo.MSIE) setTimeout("location.reload()", 10000);
        }
    }

	const delfinoDownloadClickHandler = async () => {
        await UIUtil.alert(<>보안프로그램 설치 완료 후<br/>새로고침 진행해 주세요</>);

		let downURL: string;
		if (DC_platformInfo.Mac) {
			downURL = DelfinoConfig.installPkg.Mac32;
			if (DC_platformInfo.x64) downURL = DelfinoConfig.installPkg.Mac64;
		} else if (DC_platformInfo.Ubuntu) {
			downURL = DelfinoConfig.installPkg.Dev32;
			if (DC_platformInfo.x64) downURL = DelfinoConfig.installPkg.Dev64;
		} else if (DC_platformInfo.Fedora) {
			if(Delfino.getModule() == "G3"){
                UIUtil.alert("설치완료 후, 어플리케이션 메뉴에서 델피노(delfino)를 실행하세요.\n(또는 커맨드라인에서 delfino를 입력하여 실행하세요.)");
			}
			downURL = DelfinoConfig.installPkg.Rpm32;
			if (DC_platformInfo.x64)
				downURL = DelfinoConfig.installPkg.Rpm64;
		} else if (DC_platformInfo.iOS) {
			downURL = DelfinoConfig.installPkg.iOS;
		} else if (DC_platformInfo.Android) {
			downURL = DelfinoConfig.installPkg.Android;
		} else {
			downURL = DelfinoConfig.installPkg.Win32;
			if (DC_platformInfo.x64)
				downURL = DelfinoConfig.installPkg.Win64;
		}
		load_cnt = 0;
		document.cookie="PageReload=Y; path=/;";
		document.location = downURL;
	}

	React.useEffect(()=> {
		checkTouchEnNx();
		delfino_load();

        return () => {
            clearInterval(TouchEnNxKeyInstall);
        }
	},[])

    const refreshButtonClickHandle = () => {
        window.location.reload();
    }

    return (
        <PageContainer session={false}>
            <div className='fww-con'>
                <ul className="fww-brd">
                    <li><Link to="/main/">홈</Link></li>
                    <li><Link to="#">보안프로그램 설치</Link></li>
                </ul>
                <main className="fww-main" data-layout="usr">
                    <div className="curity-program">
                        <h1 className="tx tx-hd2">보안프로그램 설치</h1>
                        <h3 className="curity-title mb30">고객님의 안전한 서비스를 위해 보안 프로그램을 설치 하셔야 합니다.</h3>
                        <div className="tb tb-narrow mb20">
                            <table>
                                <caption>보안프로그램 목록</caption>
                                <colgroup>
                                    <col width="230px"/>
                                    <col/>
                                    <col width="230px"/>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th scope="col">프로그램명</th>
                                    <th scope="col">프로그램 설명</th>
                                    <th scope="col">설치여부</th>
                                </tr>
                                </thead>
                                <tbody>

                                <tr>
                                    <td>
                                        키보드보안<br/><strong>(TouchEnNxKey with E2E)</strong>
                                    </td>
                                    <td className="ta-left">
                                        본 제품은 불법적인 키보드 입력 값을 가로채가려는 시도를 원천적으로 방어할 수 있는 솔루션으로,<br/>사용자 컴퓨터의 H/W 레벨에서 키보드가
                                        입력되는 순간부터 입력 값을 암호화여 데이터를 전송하는 솔루션입니다.
                                    </td>
                                    <td>
                                        {touchEnExInstall?<Button color='gray' size="sm" disabled>설치됨</Button>:<Button color='pri' size="sm" onClick={touchEnExDownloadClickHandler}>설치</Button>}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        공동인증서 보안<br/><strong>(WIzIN-Delfino G3/G4)</strong>
                                    </td>
                                    <td className="ta-left">
                                        WizIN-Delfino(공동인증 전자서명 프로그램)은 강력한 PKI(공개키 기반) 보안 기술을 적용하여 안전한 금융거래를 이용하실 수 있도록
                                        하는 프로그램입니다.
                                    </td>
                                    <td>
                                        {delfinoInstall?<Button color='gray' size="sm" disabled>설치됨</Button>:<Button color='pri' size="sm" onClick={delfinoDownloadClickHandler}>설치</Button>}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="hz-root hz-center mb30">
                            <button className="bt" data-color="gray-o" data-size="md"  type="button" onClick={refreshButtonClickHandle}>새로고침</button>
                        </div>
                        <h3 className="section-title mb30"><span
                            className="fc-pri fw500">키보드 보안 (TouchEnNxKey with E2E)</span></h3>
                        <ul className="curity-info mb30">
                            <li>
                                <span className="num">1.</span><strong>입력 값 보호 기능(키로깅 방지)</strong>
                                입력 값 보호기능은 자체적으로 개발한 키보드 디바이스 드라이버와 어플리케이션 간의 독자적인 데이터 전송 및 화면 출력기능을 제공하여 키로깅 방지를 제공합니다.
                            </li>
                            <li>
                                <span className="num">2.</span><strong>E2E 연동기능 (구간암호화)</strong>
                                E2E 연동기능은 커널레벨에서 암호화 후 PKI 또는 자체 암호화 모듈을 이용하여 데이터를 암호화를 진행하여 서버까지의 모든 구간에 암호화된 데이터를 전송하는
                                기능을 제공합니다.
                            </li>
                        </ul>
                        <div className="tb tb-narrow mb30">
                            <table>
                                <caption></caption>
                                <colgroup>
                                    <col/>
                                    <col width="200px"/>
                                    <col width="200px"/>
                                    <col width="200px"/>
                                    <col width="200px"/>
                                    <col width="200px"/>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th scope="col">구분</th>
                                    <th scope="col">Internet Explorer</th>
                                    <th scope="col">Edge</th>
                                    <th scope="col">Chrome</th>
                                    <th scope="col">Safari</th>
                                    <th scope="col">Firefox</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td><strong>Windows</strong><br/>XP ~ 11(32bit/64bit)</td>
                                    <td>9.0이상</td>
                                    <td>25이상</td>
                                    <td>38.0이상</td>
                                    <td>5.1.7이상</td>
                                    <td>36.0이상</td>
                                </tr>
                                <tr>
                                    <td><strong>MAC</strong></td>
                                    <td>미지원</td>
                                    <td>미지원</td>
                                    <td colSpan={3}>가상키패드</td>
                                </tr>
                                <tr>
                                    <td><strong>Linux</strong></td>
                                    <td>미지원</td>
                                    <td>미지원</td>
                                    <td colSpan={3}>가상키패드</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <ul className="curity-spec mb30">
                            <li>CPU : Pentium II이상 / RAM : 64MB이상 / HDD : 10MB 이상의 저장공간</li>
                            <li>키보드타입 PS/2 Type : 101key/102key/103key/106key 키보드</li>
                            <li>USB Type : 101key</li>
                        </ul>
                        <h3 className="section-title mb30"><span
                            className="fc-pri fw500">공동인증서 보안 (WIzIN-Delfino G3/G4)</span></h3>
                        <ul className="curity-info mb30">
                            <li>
                                <span className="num">1.</span><strong>사용자 인증</strong>
                                사용자 인증에 사용될 공동인증서 제출 및 검증 기능 제공.
                            </li>
                            <li>
                                <span className="num">2.</span><strong>전자서명 수행 및 검증</strong>
                                공동인증서를 이용한 전자서명 및 전자서명의 진위와 서명자 확인
                            </li>
                            <li>
                                <span className="num">3.</span><strong>전자봉투</strong>
                                공동인증서에 포함된 식별번호를 이용하여 인증서 소유자의 신원확인 지원
                            </li>
                        </ul>
                        <div className="tb tb-narrow mb30">
                            <table>
                                <caption></caption>
                                <colgroup>
                                    <col/>
                                    <col width="200px"/>
                                    <col width="200px"/>
                                    <col width="200px"/>
                                    <col width="200px"/>
                                    <col width="200px"/>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th scope="col">구분</th>
                                    <th scope="col">Internet Explorer</th>
                                    <th scope="col">Edge</th>
                                    <th scope="col">Chrome</th>
                                    <th scope="col">Safari</th>
                                    <th scope="col">Firefox</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td><strong>Windows</strong><br/>XP ~ 11(32bit/64bit)</td>
                                    <td>지원<br/>6.0 이상</td>
                                    <td>지원</td>
                                    <td>지원<br/>38.0 이상</td>
                                    <td>지원<br/>32.0 이상</td>
                                    <td>지원<br/>5.1.7 이상</td>
                                </tr>
                                <tr>
                                    <td><strong>MAC</strong><br/>OS X 10.6~ 10.13</td>
                                    <td>미지원</td>
                                    <td>미지원</td>
                                    <td>지원<br/>38.0 이상</td>
                                    <td>지원<br/>32.0 이상</td>
                                    <td>지원<br/>5.1.7 이상</td>
                                </tr>
                                <tr>
                                    <td><strong>Linux</strong><br/>14.04, 16.04, 17.04, 17.10</td>
                                    <td>미지원</td>
                                    <td>미지원</td>
                                    <td>지원<br/>38.0 이상</td>
                                    <td>지원<br/>32.0 이상</td>
                                    <td>미지원</td>
                                </tr>
                                <tr>
                                    <td><strong>Linux Fedora</strong><br/>22-25</td>
                                    <td>미지원</td>
                                    <td>미지원</td>
                                    <td>지원<br/>38.0 이상</td>
                                    <td>지원<br/>32.0 이상</td>
                                    <td>미지원</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </main>
            </div>
        </PageContainer>
    );
}

export default ContentsContainer;